<hvl-form-item [formGroup]="formGroup" label="{{ label | translate }}" key="{{ name }}">
    <textarea pInputTextarea [id]="inputId" [name]="name" [formControlName]="name" [rows]="rows" [cols]="cols" [autoResize]="autoResize"></textarea>
</hvl-form-item>
